export default "__VITE_PUBLIC_ASSET__b2bf743d__"